export const actionTypes = {
    SET_VISITOR_METRICS_DATA: 'SET_VISITOR_METRICS_DATA',
    SET_VISITOR_METRICS_CANCEL_TOKEN: 'SET_VISITOR_METRICS_CANCEL_TOKEN',
    IS_VISITOR_METRICS_FETCHING: 'IS_VISITOR_METRICS_FETCHING'
}